function normalizeDisplayText (value, replacements) {
  if (value === null || value === undefined) {
    return value
  }

  const text = String(value)
  return replacements.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), text)
}

function formatHalfWidthComma (value) {
  return normalizeDisplayText(value, [[/，/g, ',']])
}

function formatHalfWidthColon (value) {
  return normalizeDisplayText(value, [[/：/g, ':']])
}

function formatFourPillarsDisplay (value) {
  return formatHalfWidthComma(value)
}

function formatLunarDateDisplay (value) {
  return formatHalfWidthComma(value)
}

function formatTrueSolarTimeDisplay (value) {
  return formatHalfWidthColon(value)
}

function formatFateDisplayData (fateData = {}) {
  return {
    ...fateData,
    fourPillars: formatFourPillarsDisplay(fateData.fourPillars),
    lunarDate: formatLunarDateDisplay(fateData.lunarDate),
    trueSolarTime: formatTrueSolarTimeDisplay(fateData.trueSolarTime)
  }
}

module.exports = {
  formatHalfWidthComma,
  formatHalfWidthColon,
  formatFourPillarsDisplay,
  formatLunarDateDisplay,
  formatTrueSolarTimeDisplay,
  formatFateDisplayData
}
